import * as React from "react";
import { hasNavigationAccess, NavigationSidebarItemsList } from "@/components/sidebar/Sidebar.const";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import { SidebarIconItem } from "./SidebarIconItem";

export const SidebarNavigation: React.FC = () => {
  const userData = useAuthenticatedUser();

  return (
    <>
      {NavigationSidebarItemsList.map((item, index) => {
        if (item.type === "separator") {
          return <div key={`separator-${index}`} className="my-2 w-6 border-t border-gray-400" />;
        }

        if (item.type !== "item" || !item.icon) return null;

        const hasRequiredFeature = hasNavigationAccess(item, feature => userData.features.includes(feature));

        if (!hasRequiredFeature) return null;

        const tooltipContent = item.tooltip ?? item.name;

        return <SidebarIconItem key={item.name} href={item.href || "#"} tooltip={tooltipContent} icon={item.icon} />;
      })}
    </>
  );
};
